import { formatCurrency } from "@feature/quotations/quotation-draft/lib/format";
import { ModalOpenerButton } from "./ModalOpenerButton";
import {ResalesProductsDimension} from "./Resales.type";


export const getColumns = (
  intl:any,
  setShowWorksites:((value:string[])=>void),
  setShowQuotations:(value:number[])=>void,
  showPotential:boolean,
  productsOrResales:ResalesProductsDimension,
  valueOrQuantity:"value"|"quantity",
) => {
  const getField = (field: string) => {
    if (productsOrResales === 'products') {
      return `${field}_${valueOrQuantity}`;
    } else {
      return field + '_value';
    }
  }
  const renderField = (rowData: any, field: string) => {
    if (productsOrResales === 'products') {
      if (valueOrQuantity === "quantity") {
        return rowData[field + "_" + valueOrQuantity]?.toFixed(2) + rowData['quantity_uom'];
      } else {
        return formatCurrency(rowData[field + "_" + valueOrQuantity]);
      }
    } else {
      return formatCurrency(rowData[field + "_value"]);
    }
  }

  return [
    {
      title: intl.formatMessage({
        id: "name"
      }),
      field: "description",
      minWidth: 200,
    },
    {
      title: intl.formatMessage({
        id: "total"
      }),
      field: getField("total"),
      filtering: false,
      render: (rowData: any) => renderField(rowData, "total")
    },
    ...(!showPotential?[{
      title: intl.formatMessage({
        id: "approved",
        defaultMessage: "Preventivo Accettato"
      }),
      field: getField("approved"),
      filtering: false,
      render: (rowData: any) => renderField(rowData, "approved")
    }]:[]),
    ...(!showPotential?[{
      title: intl.formatMessage({
        id: "waiting",
        defaultMessage: "Preventivo In Attesa"
      }),
      field: getField("waiting"),
      filtering: false,
      render: (rowData: any) => renderField(rowData, "waiting")
    }]:[]),
    ...(productsOrResales == 'products' && !showPotential?[{
      title: intl.formatMessage({
        id: "not_quoted",
        defaultMessage: "Non Preventivato"
      }),
      field: getField("not_quoted"),
      filtering: false,
      render: (rowData: any) => renderField(rowData, "not_quoted")
    }]:[]),
    ...(showPotential?[{
      title: intl.formatMessage({
        id: "potential",
        defaultMessage: "Potenziale"
      }),
      field: getField("potential"),
      filtering: false,
      render: (rowData: any) => renderField(rowData, "potential")
    }]:[]),
    {
      title: intl.formatMessage({
        id: "worksites",
        defaultMessage: "Cantieri"
      }),
      filtering: false,
      field: "worksites",
      render: (rowData: any) => rowData.worksites.length?
        ModalOpenerButton(
          {
            value:rowData.worksites,
            stateSetterFn: setShowWorksites
          }
        ): "-"
    },
    {
      title: intl.formatMessage({
        id: "quotation_ids",
        defaultMessage: "preventivi"
      }),
      filtering: false,
      field: "quotation_ids",
      render: (rowData:any) => rowData.quotation_ids.filter((q:number)=>q).length?
        ModalOpenerButton(
          {
            value:rowData.quotation_ids.filter((q:number)=>q),
            stateSetterFn: setShowQuotations
          }
        ): "-"
    },
  ];

}